export default "__VITE_ASSET__W6qKkZIL__"